import { render } from "./VendorItemsList.vue?vue&type=template&id=a368402e"
import script from "./VendorItemsList.vue?vue&type=script&lang=js"
export * from "./VendorItemsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__